export default "__VITE_ASSET__93318215__"